import { VideoOverlay } from '../../state/VideoOverlay';

type SortComparator<T> = (firstEl: T, secondEl: T) => number;

export const sortToDescendingPriority: SortComparator<VideoOverlay> = (overlayA, overlayB): number => {
  const diff = (overlayB.priority - overlayA.priority);
  if (diff !== 0) return diff;

  return overlayB.createdAt - overlayA.createdAt;
};
